import React from "react";
import ReactSelect from "./ReactSelect";

class CustomReactSelect extends React.Component {
  render() {
    const { isValid, submitted, ...rest } = this.props;

    return (
      <ReactSelect
        {...rest}
        noFormGroup
        errors={isValid}
        invalid={Boolean(submitted && isValid && isValid.length)}
      />
    );
  }
}
export default CustomReactSelect;
